// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-panel-border[data-v-15111685]:not(:last-child) {\n  border-bottom: 1px solid black;\n}\n.tile-border[data-v-15111685] {\n  border-radius: 20px !important;\n}\n.custom-panel-heading[data-v-15111685] {\n  border-radius: 20px 20px 0 0 !important;\n  background-color: #495057 !important;\n}\n", ""]);
// Exports
module.exports = exports;
